import GlyphIcon from "./GlyphIcon.mjs";

const AttachIcon = class extends GlyphIcon {
	render() {
		return(
			<GlyphIcon
				d="M25.89935,19.82837l-6.42474,6.42468a8.50972,8.50972,0,0,1-12.02051.00012l-.707-.70727A8.50109,8.50109,0,0,1,6.7478,13.52441l7.739-7.73913A6.65164,6.65164,0,0,1,23.195,5.05945a6.50828,6.50828,0,0,1,.64386,9.75854l-7.89942,7.89954a3.49987,3.49987,0,0,1-4.94989-.00024l-.61871-.61866a3.65625,3.65625,0,0,1-1.0528-1.91089,3.50173,3.50173,0,0,1,.96466-3.12719l5.71717-5.71729a.99986.99986,0,0,1,1.41424,0l.707.707a1,1,0,0,1,0,1.41419L12.40381,19.182a.506.506,0,0,0,0,.70715l.707.707a.507.507,0,0,0,.70752,0l7.83081-7.83081a3.56136,3.56136,0,0,0,.53522-4.44592,3.50727,3.50727,0,0,0-5.41681-.57239L8.86835,15.64624a5.50032,5.50032,0,0,0-.00019,7.77844l.707.70716a5.49993,5.49993,0,0,0,7.77813.00012l6.42487-6.42481a1,1,0,0,1,1.41424.00013l.707.707A.99984.99984,0,0,1,25.89935,19.82837Z"
				{...this.props}
			/>
		);
	}
}

export default AttachIcon;